import type { ThemeConfig } from 'antd'
import { lightColors, radius } from '@horizon/tokens'

/**
 * The admin uses the same semantic palette as the student product. Ant's
 * component tokens are mapped here once so screens never invent a parallel
 * visual language.
 */
export const adminTheme: ThemeConfig = {
  token: {
    colorPrimary: lightColors.accentPrimary,
    colorInfo: lightColors.statusInfo,
    colorSuccess: lightColors.statusSuccess,
    colorWarning: lightColors.statusWarning,
    colorError: lightColors.statusError,
    colorText: lightColors.textPrimary,
    colorTextSecondary: lightColors.textSecondary,
    colorBorder: lightColors.borderDefault,
    colorBgLayout: lightColors.bgCanvas,
    colorBgContainer: lightColors.bgSurface,
    colorBgElevated: lightColors.bgSurfaceRaised,
    borderRadius: radius.md,
    borderRadiusLG: radius.lg,
    controlHeight: 42,
    fontFamily: 'Sora, system-ui, sans-serif',
    fontFamilyCode: 'IBM Plex Mono, ui-monospace, monospace',
  },
  components: {
    Button: {
      primaryShadow: 'none',
      borderRadius: radius.sm,
      fontWeight: 600,
    },
    Card: {
      borderRadiusLG: radius.lg,
      paddingLG: 20,
    },
    Input: {
      activeShadow: `0 0 0 2px ${lightColors.accentPrimarySubtle}`,
    },
    Layout: {
      bodyBg: lightColors.bgCanvas,
      headerBg: lightColors.bgCanvas,
      siderBg: lightColors.bgSurface,
    },
    Menu: {
      itemBorderRadius: radius.sm,
      itemSelectedBg: lightColors.accentPrimarySubtle,
      itemSelectedColor: lightColors.accentPrimary,
      itemHoverBg: lightColors.bgSubtle,
    },
    Table: {
      headerBg: lightColors.bgSubtle,
      headerColor: lightColors.textSecondary,
      rowHoverBg: lightColors.accentPrimarySubtle,
      borderColor: lightColors.borderDefault,
    },
    Tabs: {
      inkBarColor: lightColors.accentPrimary,
      itemSelectedColor: lightColors.accentPrimary,
      itemHoverColor: lightColors.accentPrimaryHover,
    },
  },
}
